export default "__VITE_ASSET__$yAFSy7g__"